import styled from 'styled-components';
import { Box } from '@components/common';

const AuthFormsWrapper = styled(Box)`
  max-width: 345px;
  min-width: 320px;
  margin: auto;
`;

export default AuthFormsWrapper;
